import { Navigate, useLocation } from 'react-router';

import { useAuth } from '@/auth/useAuth';
import { TodayPage } from '@/features/today/TodayPage';
import { useModules } from '@/modules/ModuleContext';
import { landsInField } from '@/shell/landing';

/** The key React Router gives the first location of a page load; every later one gets its own. */
const FIRST_ENTRY_KEY = 'default';

/**
 * The page at `/`: Today for most people, Field for technicians who open the app here.
 *
 * Only opening the app at `/` sends a technician on. A link to Today inside the app must still
 * open it: the field shell's way back to the workspace is exactly such a link, and so is Today in
 * the rail of someone who holds a desk role as well.
 *
 * @returns the home screen, or a redirect into Field
 */
export function HomeRoute(): React.JSX.Element {
  const { can } = useAuth();
  const enabled = useModules();
  const { key } = useLocation();

  if (key === FIRST_ENTRY_KEY && landsInField({ can, enabled })) {
    return <Navigate to="/field" replace />;
  }
  return <TodayPage />;
}
